import { ImprovedProduct } from "./Product";

// Enum to define the allowed time periods
export enum TimePeriod {
  All = "ALL",
  Future_Only = "future",
  Active_Only = "0",
  Three_Days_Ended = "3",
  Fourteen_Days_Ended = "14",
  Thirty_Days_Ended = "30",
}

export enum SortOrder {
  NAME_ALPHABETICAL = "NAME_ALPHABETICAL",
  NAME_REVERSE_ALPHABETICAL = "NAME_REVERSE_ALPHABETICAL",
  END_DATE = "END_DATE",
  REVERSE_END_DATE = "REVERSE_END_DATE",
}

export interface ItemNeeded {
  sku: string;
  product_name: string;
  quantity: number;
  is_custom: boolean;
}

export interface WarehouseFundraiserPayout {
  total_collected: number;
  mamfam_profit: number;
  total_amount_owed: number;
  total_paid_so_far: number;
  total_paid_remaining: number;
}

export interface WarehouseItems {
  needed_skus: ItemNeeded[];
  fundraiser_payout: WarehouseFundraiserPayout;
}
export interface InventoryStockResponse extends ImprovedProduct {
  quantity: number;
}
export type InventoryUpdateReason =
  | "RESTOCK"
  | "ORDER_FULFILLMENT"
  | "RETURN"
  | "SAMPLE"
  | "ADJUSTMENT"
  | "REPLACEMENT"
  | "OTHER";

// Groups
export const POSITIVE_REASONS: InventoryUpdateReason[] = ["RESTOCK", "RETURN"];
export const NEGATIVE_REASONS: InventoryUpdateReason[] = [
  "ORDER_FULFILLMENT",
  "SAMPLE",
  "REPLACEMENT",
];
export const NEUTRAL_REASONS: InventoryUpdateReason[] = ["ADJUSTMENT", "OTHER"];

export const INVENTORY_UPDATE_REASON_OPTIONS: {
  value: InventoryUpdateReason;
  label: string;
}[] = [
  { value: "RESTOCK", label: "Restock" },
  { value: "ORDER_FULFILLMENT", label: "Order Fulfillment" },
  { value: "RETURN", label: "Return" },
  { value: "SAMPLE", label: "Sample" },
  { value: "ADJUSTMENT", label: "Adjustment" },
  { value: "REPLACEMENT", label: "Replacement" },
  { value: "OTHER", label: "Other" },
];

export interface InventoryStockUpdate {
  product: number;
  increment: number;
  reason: InventoryUpdateReason;
  reason_detail: string;
  order?: number;
  account: number;
}

export interface InventoryStockDisplayResponse {
  id: number;
  product_sku: number;
  product_name: string;
  increment: number;
  order: number | null;
  reason: InventoryUpdateReason;
  reason_detail: string;
  account_name: string;
  created_at: string;
}

export interface PaginatedInventoryResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: InventoryStockDisplayResponse[];
}
